import { action } from 'typesafe-actions';

import { TaxTypes, TaxInterface } from './types';

// List Tax
export const listTaxRequest = (payload: object) =>
  action(TaxTypes.LIST_TAX_REQUEST, payload);

export const listTaxSuccess = (payload: { taxList: TaxInterface[] }) =>
  action(TaxTypes.LIST_TAX_SUCCESS, payload);

export const listTaxFailure = () => action(TaxTypes.LIST_TAX_FAILURE);

// Get Tax
export const getTaxRequest = (payload: object) =>
  action(TaxTypes.GET_TAX_REQUEST, payload);

export const getTaxSuccess = (payload: { taxData: TaxInterface }) =>
  action(TaxTypes.GET_TAX_SUCCESS, payload);

export const getTaxFailure = () => action(TaxTypes.GET_TAX_FAILURE);

// Create Tax
export const createTaxRequest = (payload: any) =>
  action(TaxTypes.CREATE_TAX_REQUEST, payload);

export const createTaxSuccess = (payload: { taxData: TaxInterface }) =>
  action(TaxTypes.CREATE_TAX_SUCCESS, payload);

export const createTaxFailure = () => action(TaxTypes.CREATE_TAX_FAILURE);

// Update Tax
export const updateTaxRequest = (payload: any) =>
  action(TaxTypes.UPDATE_TAX_REQUEST, payload);

export const updateTaxSuccess = (payload: { taxData: TaxInterface }) =>
  action(TaxTypes.UPDATE_TAX_SUCCESS, payload);

export const updateTaxFailure = () => action(TaxTypes.UPDATE_TAX_FAILURE);

// Delete Tax
export const deleteTaxRequest = (payload: object) =>
  action(TaxTypes.DELETE_TAX_REQUEST, payload);

export const deleteTaxSuccess = () => action(TaxTypes.DELETE_TAX_SUCCESS);

export const deleteTaxFailure = () => action(TaxTypes.DELETE_TAX_FAILURE);

// Attach Tax
export const attachTaxRequest = (payload: any) =>
  action(TaxTypes.ATTACH_TAX_REQUEST, payload);

export const attachTaxSuccess = () => action(TaxTypes.ATTACH_TAX_SUCCESS);

export const attachTaxFailure = () => action(TaxTypes.ATTACH_TAX_FAILURE);

// Detach Tax
export const detachTaxRequest = (payload: object) =>
  action(TaxTypes.DETACH_TAX_REQUEST, payload);

export const detachTaxSuccess = () => action(TaxTypes.DETACH_TAX_SUCCESS);

export const detachTaxFailure = () => action(TaxTypes.DETACH_TAX_FAILURE);
